define(['jquery'], function ($) {
   "use strict";

   var m_aFavoriteProperties = [],
      m_aFavoriteAgents = [],
      m_aFavoriteOffices = [],
      m_aHiddenProperties = [],
      m_aHiddenAgents = [],
      m_aHiddenOffices = [],

      // FIXME: This function will only return accurate favorites from the initially loaded page
      //        BUT since the user can change favorites w/o reloading the page, the
      //        information eventually becomes outdated...
      arrayContains = function (arr, value) {
         var i = arr.length;

         while (i--) {
            if (arr[i] === value) {
               return true;
            }
         }

         return false;
      },

      add = function (aItems, sId) {
         if (!arrayContains(aItems, sId)) {
            var lastIndex = aItems.length;
            aItems[lastIndex] = sId;
         }
      },

      remove = function (aItems, sId) {
         var i = aItems.length;

         if (arrayContains(aItems, sId)) {
            while (i--) {
               if (aItems[i] === sId) {
                  aItems.splice(i, 1);
               }
            }
         }
      },

      setHidden = function (aItems, elId, sId) {
         if (arrayContains(aItems, sId)) {
            $("#" + elId).addClass('hidden');
         }
      },

      /**
       * Set the favorite [blank]   
       * @param aItems {Array} the items to check against
       * @param elId {String|jQuery} the element to change
       * @param sId {String} the item's id
       * @return {Boolean} True if the item is a favorite, otherwise False
       */
      setFavorite = function (aItems, elId, sId) {
         var jEl = (typeof elId === "string") ? $("#" + elId) : elId,
            bFavorite = arrayContains(aItems, sId);

         jEl.toggleClass('favorite', bFavorite);
         return bFavorite;
      };

   return {
      /* FAVORITE PROPERTY */
      initializeFavoriteProperties: function (aProperties) {
         m_aFavoriteProperties = aProperties;
      },

      setFavoriteProperty: function (elId, sId) {
         return setFavorite(m_aFavoriteProperties, elId, sId);
      },

      addFavoriteProperty: function (sId) {
         add(m_aFavoriteProperties, sId);
      },

      removeFavoriteProperty: function (sId) {
         remove(m_aFavoriteProperties, sId);
      },

      /* HIDDEN PROPERTY */
      initializeHiddenProperties: function (aProperties) {
         m_aHiddenProperties = aProperties;
      },

      setHiddenProperty: function (elId, sId) {
         setHidden(m_aHiddenProperties, elId, sId);
      },

      addHiddenProperty: function (sId) {
         add(m_aHiddenProperties, sId);
      },

      removeHiddenProperty: function (sId) {
         remove(m_aHiddenProperties, sId);
      },

      /* FAVORITE AGENT */
      initializeFavoriteAgents: function (aAgents) {
         m_aFavoriteAgents = aAgents;
      },

      setFavoriteAgent: function (elId, sId) {
         return setFavorite(m_aFavoriteAgents, elId, sId);
      },

      addFavoriteAgent: function (sId) {
         add(m_aFavoriteAgents, sId);
      },

      removeFavoriteAgent: function (sId) {
         remove(m_aFavoriteAgents, sId);
      },

      /* HIDDEN AGENT */
      initializeHiddenAgents: function (aAgents) {
         m_aHiddenAgents = aAgents;
      },

      setHiddenAgent: function (elId, sId) {
         setHidden(m_aHiddenAgents, elId, sId);
      },

      addHiddenAgent: function (sId) {
         add(m_aHiddenAgents, sId);
      },

      removeHiddenAgent: function (sId) {
         remove(m_aHiddenAgents, sId);
      },

      /* FAVORITE OFFICE */
      initializeFavoriteOffices: function (aOffices) {
         m_aFavoriteOffices = aOffices;
      },

      setFavoriteOffice: function (elId, sId) {
         return setFavorite(m_aFavoriteOffices, elId, sId);
      },

      addFavoriteOffice: function (sId) {
         add(m_aFavoriteOffices, sId);
      },

      removeFavoriteOffice: function (sId) {
         remove(m_aFavoriteOffices, sId);
      },

      /* HIDDEN OFFICE */
      initializeHiddenOffices: function (aOffices) {
         m_aHiddenOffices = aOffices;
      },

      setHiddenOffice: function (elId, sId) {
         setHidden(m_aHiddenOffices, elId, sId);
      },

      addHiddenOffice: function (sId) {
         add(m_aHiddenOffices, sId);
      },

      removeHiddenOffice: function (sId) {
         remove(m_aHiddenOffices, sId);
      }
   };
});
